import React from 'react';
import { FDBox, FDContentContainer } from '@facet-wealth/design';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';

export const AccountRetitlingSuccessLayout = ({ resource }) => {
  return (
    <FDContentContainer>
      <FDBox paddingY={8}>
        <ImageRel height={'175px'} relationship={resource.relationship(fr.relationships.image.name)} />
        <PageContentTop
          resource={resource}
          title={resource.attr('title')}
          subtitle={resource.attr('subtitle')}
        />
      </FDBox>

    </FDContentContainer>
  );
};

AccountRetitlingSuccessLayout.defaultProps = {
};

AccountRetitlingSuccessLayout.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
